import ReactDOM from 'react-dom';
import React from 'react';
import './styles/index.css';
import App from './components/dumb/App';

ReactDOM.render(<App />, document.getElementById('root'));


